import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["productId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { useCrossFlow } from '@atlassiansox/cross-flow-component-support';
import { FlightDeckClient } from '@atlassiansox/flight-deck-frontend-client';
export var useAppProvisioning = function useAppProvisioning() {
  var crossFlow = useCrossFlow();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    appKeyMappings = _useState2[0],
    setAppKeyMappings = _useState2[1];
  useEffect(function () {
    var client = new FlightDeckClient('app-provisioning');
    client.fetchConfigFromFlightDeck({
      name: 'discovery-sdk',
      dimensions: {
        environmentType: 'prod'
      }
    }).then(function (mappings) {
      return setAppKeyMappings(mappings);
    }).catch(function () {});
  }, []);
  return function (_ref) {
    var productId = _ref.productId,
      rest = _objectWithoutProperties(_ref, _excluded);
    // TODO: check if the app is 1P, 2P or 3P and create the provision context accordingly.
    // This can be done through Unified Listing API.
    // https://hello.atlassian.net/wiki/spaces/ECON/pages/2303960596/Project+Plan+Unified+Listing+API
    // At the moment, we only support provisioning 1P apps.

    if (!crossFlow.isEnabled || !appKeyMappings || !appKeyMappings.products[productId]) {
      return Promise.resolve({
        success: false
      });
    }
    var _appKeyMappings$produ = appKeyMappings === null || appKeyMappings === void 0 ? void 0 : appKeyMappings.products[productId],
      crossFlowReferenceId = _appKeyMappings$produ.crossFlowReferenceId;
    return crossFlow.api.open(_objectSpread({
      targetProduct: crossFlowReferenceId
    }, rest));
  };
};
export function withAppProvisioning(WrappedComponent) {
  var ComponentWithAppProvisioning = function ComponentWithAppProvisioning(props) {
    var appProvisioning = useAppProvisioning();
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      appProvisioning: appProvisioning
    }));
  };
  ComponentWithAppProvisioning.displayName = "withAppProvisioning(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
  return ComponentWithAppProvisioning;
}